import { Component } from '@angular/core';

import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';
import { FieldOption } from '@shared/models';

@Component({
  selector: 'lib-form-radio-list',
  styleUrls: ['form-radio-list.component.scss'],
  templateUrl: 'form-radio-list.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    FormFieldErrorComponent,
  ],
})
export class FormRadioListComponent extends FieldBaseComponent {
  public onChange(option: string | number | boolean) {
    if (this.config?.onRadioChange) {
      this.config.onRadioChange(option);
    }
  }

  public getCheckGroupDisplayTypeClass() {
    switch (this.config?.displayType) {
      case 'button-group':
        return `bg-white py-1 rounded-2 btn-group d-flex border border-colour-${this.invalid ? 'red-800' : 'grayscale-600'}`;
      case 'radio':
      default:
        return '';
    }
  }

  public getCheckDisplayTypeClass(first: boolean) {
    switch (this.config?.displayType) {
      case 'button-group':
        return `col m-0 px-1 ${first ? '' : ' border-start'}`;
      case 'radio':
      default:
        return '';
    }
  }

  public getInputDisplayTypeClass() {
    switch (this.config?.displayType) {
      case 'button-group':
        return 'd-none';
      case 'radio':
      default:
        return '';
    }
  }

  public getLabelDisplayTypeClass(item: FieldOption) {
    switch (this.config?.displayType) {
      case 'button-group':
        const colour = this.formGroup?.value[this.config.name] === item.value ? 'colour-blue-600' : 'white';
        return `btn w-100 py-1 btn-${colour}`;
      case 'radio':
      default:
        return '';
    }
  }
}
